import style from './style.module.css'

export default function TextArea({ value, onchange, label }){
    return (
        <div className='form-group'>
            <label>{ label }</label>
            <textarea className={ style.textarea + ' form-control' } onChange={onchange}  rows='5'/>
        </div>
    )
}